import type { Capabilities } from '@mai-fixed-asset/contracts';
import { useQuery } from '@tanstack/react-query';
import { AssetQueryKey, assetApi } from './api.js';

const NONE: Capabilities = { canManageAssets: false, canListAssets: false, canAdminister: false };

/** What the signed-in user may do here (nothing until it has loaded). */
export function useCapabilities(): Capabilities {
  const capabilities = useQuery({
    queryKey: AssetQueryKey.Capabilities,
    queryFn: assetApi.capabilities,
  });
  return capabilities.data ?? NONE;
}
